import { useTranslations } from 'next-intl';
import { toast } from '../components/ui/use-toast';
import { containersGetShareToken } from '../services/vidu';
import { useCopy, useFetch } from '.';

export const useAgentContainerShare = () => {
  const t = useTranslations();
  const { copyAsync } = useCopy();
  const { loading: getShareTokenLoading, runAsync: getAgentContainerShareToken } = useFetch(
    (containerId: string) =>
      containersGetShareToken({
        path: {
          id: containerId,
        },
        body: {
          id: containerId,
        },
      }),
    { manual: true },
  );

  const handleAgentContainerShare = async (containerId: string) => {
    try {
      // 创建一个 Promise 来获取分享链接
      const getShareUrlPromise = getAgentContainerShareToken(containerId).then((res) => {
        if (res.error) {
          toast({
            type: 'error',
            message: t('popup.dialog.share.shareUrlFailed'),
          });
          return null;
        }
        return `${window.location.origin}/share/agent-creation/${containerId}/${res?.data?.token}`;
      });

      // 在用户手势上下文中调用 copyAsync，传入 Promise
      await copyAsync(getShareUrlPromise, {
        copySuccessMessage: t('create.share.description'),
        placeholder: 'Generating share link...',
      });
    } catch (error) {
      console.error('Share failed:', error);
    }
  };

  return {
    handleAgentContainerShare,
    getShareTokenLoading,
  };
};
